import { posts } from "../data/posts";

const Insights = () => {
  return (
    <div>
      <div className="standard-paragraph">
        <h2>Insights</h2>
        <p>
          Practical AWS articles, project updates, case highlights, and course news.
        </p>

        {/* GRID CONTAINER */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
            gap: "20px",
            marginTop: "30px"
          }}
        >
          {posts.map((post) => (
            <div
              key={post.id}
              style={{
                border: "1px solid #ddd",
                borderRadius: "10px",
                overflow: "hidden",
                background: "#fff",
                transition: "transform 0.2s ease, box-shadow 0.2s ease",
                cursor: "pointer"
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow =
                  "0 10px 25px rgba(0,0,0,0.1)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "none";
              }}
            >
              {/* IMAGE */}
              {post.image && (
                <a href={post.link}>
                  <img
                    src={post.image}
                    alt={post.title}
                    style={{
                      width: "100%",
                      height: "180px",
                      objectFit: "contain", // keeps badges clean
                      backgroundColor: "#f5f5f5",
                      padding: "10px"
                    }}
                  />
                </a>
              )}

              {/* CONTENT */}
              <div style={{ padding: "15px" }}>
                <div
                  style={{
                    fontSize: "12px",
                    color: "#777",
                    marginBottom: "5px"
                  }}
                >
                  {post.type.toUpperCase()} • {post.date}
                </div>

                <h3 style={{ marginBottom: "10px" }}>
                  {post.title}
                </h3>

                <p style={{ marginBottom: "10px", color: "#555" }}>
                  {post.summary}
                </p>

                <a
                  href={post.link}
                  style={{
                    color: "#007bff",
                    textDecoration: "none",
                    fontWeight: "500"
                  }}
                >
                  Read more →
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Insights;